import axios from 'axios'

const devHost =
    typeof window !== 'undefined' && window.location
        ? window.location.hostname
        : 'localhost'

axios.defaults.baseURL =
    process.env.NODE_ENV === 'development'
        ? devHost === '127.0.0.1'
            ? 'http://127.0.0.1:5000'
            : 'http://localhost:5000'
        : process.env.REACT_APP_API_URL || 'http://localhost:5000'

export default axios
